
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Route, Redirect } from 'react-router'
import { ConnectedRouter } from 'react-router-redux'
import App from "./App"
import store from "./store"
import { history } from './store';

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <div className="routed">
                <Route exact path={"/start/:token"} render={(props) => {
                    store.dispatch({type:"SET_TOKEN", payload:{token:props.match.params.token}});
                    let language = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;
                    return <Redirect to={"/" + language.split("-")[0] + "/home/" + props.match.params.token}/>
                }}/>
                <Route path={"/:lang/home/:token"} component={App}/>
                <Route path={"/:lang/feedback/:token"} component={App}/>
                <Route path={"/:lang/contact/:token"} component={App}/>
                <Route path={"/:lang/imprint/:token"} component={App}/>
                <Route path={"/:lang/privacy/:token"} component={App}/>
            </div>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js